<template>

  <div>
    <l-marker ref="element"
              :lat-lng="element.locations"
              :zIndexOffset="zindex"
              :draggable="editable"
              @contextmenu="contextmenu($event)"
              @click="click($event)">

      <l-icon :icon-anchor="[0, 0]" :icon-size="[32, 40]">
        <font-awesome-layers class="marker" :class="classname">
          <font-awesome-icon icon="map-marker" size="3x" class="marker-background"></font-awesome-icon>
          <font-awesome-icon :icon="iconname" class="marker-icon" v-if="!issues"></font-awesome-icon>

          <font-awesome-layers class="marker-issues" v-if="issues">
            <font-awesome-icon icon="circle" transform="grow-6" class="issues-background"></font-awesome-icon>
            <font-awesome-icon icon="wrench" transform="shrink-4" class="issues-icon"></font-awesome-icon>
          </font-awesome-layers>
        </font-awesome-layers>
      </l-icon>

    </l-marker>
  </div>

</template>

<script>

import L from 'leaflet'
import { LMarker, LIcon } from 'vue2-leaflet'
import States from '../../services/states.es6'
import Issues from '../../services/issues.es6'
import { MapService } from '../../services/map.service.es6'
import ElementDialog from '../../dialogs/element-dialog'

export default {
  name: 'map-marker',

  props: [ 'element', 'active' ],

  data () {
    return {
      States: States,
      editable: false,
      menu: [
        { title: this.$t('map.element.properties'), icon: 'tools', action: () => this.edit() },
        { title: this.$t('map.element.move'), icon: 'arrows-alt', action: () => this.editable = true },
        { title: this.$t('map.element.remove'), icon: 'trash', action: () => MapService.removeElement(this.element) }
      ]
    }
  },

  computed: {
    classname () {
      return [
        'status-' + this.element.status,
        'issues-' + this.element.issues,
        this.active ? 'active' : null,
        this.editable ? 'editable' : null,
      ].filter(x => !!x).join(' ')
    },

    issues () {
      return this.element.issues !== Issues.EMPTY
    },

    iconname () {
      const icons = {
        ok: 'check',
        warning: 'exclamation',
        error: 'times',
        unknown: 'question'
      }

      return icons[this.element.status] + '-circle'
    },

    zindex () {
      if (this.active) {
        return 500
      }

      const status = this.element.status
      const issues = this.element.issues

      if (status === States.ERROR) {
        return 300
      }

      if (status === States.WARNING) {
        return 200
      }

      if (issues === Issues.FAILURE) {
        return 150
      }

      if (issues === Issues.MAINTENANCE) {
        return 140
      }

      if (status === States.OK) {
        return 100
      }

      return 50
    },
  },

  methods: {
    click (event) {
      this.$emit('click', event.latlng)
    },

    contextmenu (event) {
      this.$emit('menu', { event: event, data: this.menu })
    },

    async edit () {
      const result = await this.$dialog.showAndWait(ElementDialog, { element: this.element, actions: { 'false': 'No', 'true': 'Yes' } })

      if (result)
        this.$emit('save', { assetId: this.element.assetId })
    },
  },

  watch: {
    active (value) {
      if (this.editable && !value) {
        this.editable = false
        this.$emit('save', { locations: this.$refs.element.mapObject._latlng })
      }
    }
  },

  components: {
    LMarker,
    LIcon
  }
}

</script>

<style lang="scss">

@import '../../../../assets/variables';

@mixin marker($color) {
  .marker-background {
    path {
      fill: $color;
      stroke: darken($color, 5%);
      stroke-width: 20px;
    }
  }
}

@mixin issues($color) {
  .marker-issues {
    .issues-icon {
      color: $color;
    }
  }
}

.leaflet-marker-icon {
  .marker {
    position: absolute;
    top: -100%;
    left: -50%;
    width: 100%;
    height: 100%;

    .marker-icon {
      position: absolute;
      top: -9px;
      left: 0px;
      color: white;
      font-size: 15px;
    }

    .marker-issues {
      position: absolute;
      top: 9px;
      left: 11px;
      transform: translateX(-0.4px);
      z-index: 200;

      .issues-background {
        color: white;
      }
    }

    &.issues-maintenance {
      @include issues(#3f51b5);
    }

    &.issues-failure {
      @include issues(#D63E2A);
    }

    &.status-ok {
      @include marker(#70AD25);
    }

    &.status-warning {
      @include marker(#F69730);
    }

    &.status-error {
      @include marker(#D63E2A);
    }

    &.status-unknown {
      @include marker(#575757);
    }


    &.active {
      .marker-background path {
        stroke: red;
      }

      &:after {
        content: ' ';
        display: block;
        background-color: $color-primary;
        border-radius: 100px;
        width: 100px;
        height: 100px;
        top: -25px;
        left: -36px;
        position: absolute;
        opacity: 0.6;
        transform: scale(0);
        z-index: -1;

        animation-name: pulse;
        animation-duration: 2s;
        animation-iteration-count: infinite;
      }
    }

    &.editable {
      cursor: move;

      animation-name: shake;
      animation-duration: 0.7s;
      animation-iteration-count: infinite;
      transform-origin: 50% 100%;
    }
  }
}

/*
.leaflet-tooltip {
  &.marker-controls {
    $padding: 5px;
    $background: rgba(0, 0, 0, 0.5);

    top: -25px;
    left: 15px;
    padding: $padding;
    background-color: $background;
    border: none;

    .v-btn {
      $border-radius: 5px;
      border-radius: 0;
      padding-top: 8px;
      padding-bottom: 8px;
      height: auto;
      display: block;

      &:first-child {
        border-top-right-radius: $border-radius;
        border-top-left-radius: $border-radius;
      }

      &:last-child {
        border-bottom-right-radius: $border-radius;
        border-bottom-left-radius: $border-radius;
      }
    }
  }
}*/

@keyframes pulse {
  0% {
    transform: scale(0);
  }

  45% {
    transform: scaleX(1) scaleY(0.8);
  }

  90% {
    opacity: 0;
    transform: scaleX(1) scaleY(0.8);
  }

  // causes a delay after the animation
  100% {
    opacity: 0;
    transform: scaleX(1) scaleY(0.8);
  }
}

@keyframes shake {
  $degrees: 1.5deg;

  0% {
    transform: rotate(0deg);
  }

  25% {
    transform: rotate(-$degrees);
  }

  50% {
    transform: rotate(0deg)
  }

  75% {
    transform: rotate($degrees)
  }

  100% {
    transform: rotate(0deg)
  }
}
</style>
